<template>
    <div class="page-qr-redirect">
        <img class="icon"  v-if="status == 1" src="@/assets/QRredirect/img-1.png" alt="">
        <img class="icon"  v-else-if="status == 2" src="@/assets/QRredirect/img-2.png" alt="">
        <div class="title"  v-if="status">{{ tips }}</div>
        <!-- <div class="btn" :class="{teacat:brand !== 'COTTI'}" v-if="status == 2" @click="toDownload()">立即升级</div> -->
    </div>
  </template>
  
  <script>
  import { isWeixin, isCottiApp, isAlipayClient, isIOS } from "@/utils";
  import { appCheckUpdate } from "@/api"
  
  export default {
    name: 'QRredirect',
    data() {
      return {
        advertise: '',
        isLoading: false,
        status: null,
        tips: '',
        brand: this.$config.env.VUE_APP_BRAND,
      }
    },
    created() {
      this.init()
    },
    methods: {
      async init() {
        this.isLoading = true
        if (!isCottiApp() && !isWeixin() && !isAlipayClient()) {
            this.status = 1
            this.tips = '请使用库迪咖啡App/微信/支付宝扫码'
        }
        if (isCottiApp()) {
            const userAgent = navigator.userAgent.split('/')
            if (Number(userAgent[1]) < 209) {
              this.status = 2
              this.tips = 'App版本过低，请先升级后再试'
            }
            // const params = {
            //     appChannel: isIOS() || navigator.userAgent.includes('ios') ? 903 : 902,
            //     currentVersion: Number(userAgent[1])
            // }
            // const {data} = await appCheckUpdate(params)
            // if (data.forceType || data.forceType == 0) {
            //     this.status = 2
            //     this.tips = 'App版本过低，请先升级后再试'
            //     // if () {

            //     // }
            // }
        }
      },
      toDownload() {
        this.$router.push({path: '/download'})
      }
    },
    
    mounted() {
      document.body.style.backgroundColor = '#F5F5F5'
    },
    beforeDestroy() {
      document.body.style.backgroundColor = '#fff'
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .page-qr-redirect {
    .icon {
    display: block;
    width: 280px;
    height: auto;
    margin: 344px auto 24px;
  }

  .title {
    text-align: center;
    height: 40px;
    font-size: 28px;
    color: #5E5E5E;
    line-height: 40px;
  }

  .btn {
    display: block;
    margin: 40px auto 0;
    width: 216px;
    height: 80px;
    line-height: 80px;
    background: #A52337;
    border-radius: 40px;
    text-align: center;

    font-size: 28px;
    color: #FFF;
    &.teacat  {
      background: #9FCC0C;
    }
  }
  }
  </style>
  